'use es6';

export const getIsDragging = state => state.application.isDragging;